import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { computed } from "vue";
	
export default /*@__PURE__*/_defineComponent({
  __name: 'StatusDot',
  props: {
    value: {}
  },
  setup(__props: any) {

	const props = __props;
	const cls = computed(() => {
		const v = (props.value || "").toLowerCase();
		return v === "online" ? "ok" : v === "maintenance" ? "warn" : v === "error" ? "err" : "off";
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["status-data-dot", cls.value]),
    title: __props.value
  }, null, 10, _hoisted_1))
}
}

})